import classNames from 'classnames';
import './PseudoLinkText.scss';

interface IPseudoLinkText {
  label: string;
  onClick: () => void;
  className?: string | object;
}

export default function PseudoLinkText({ onClick, label, className }: IPseudoLinkText) {
  return (
    <span className={classNames('pseudo-link-text', className)} onClick={onClick}>
      {label}
    </span>
  );
}
